import {
  ADD_TO_CART, REMOVE_TO_CART, CLEAR_TO_CART, OVERLAP_TO_CART,
  ADMIN_PACKAGE_CURRENT_MAIN_INDEX,
  ADMIN_PACKAGE_CURRENT_CHILD_INDEX,
  ADD_ADMIN_PACKAGE_MAIN_ITEM,
  UPDATE_ADMIN_PACKAGE_MAIN_ITEM,
  REMOVE_ADMIN_PACKAGE_MAIN_ITEM,
  ADD_ADMIN_PACKAGE_CHILD_ITEM,
  UPDATE_ADMIN_PACKAGE_CHILD_ITEM,
  REMOVE_ADMIN_PACKAGE_CHILD_ITEM,
  CLEAR_ADMIN_PACKAGE_CART,
  SET_ADMIN_PACKAGE_CART,
  SET_CUSTOMER_PACKAGE_CART,
  UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM,
  SET_CUSTOMER_DISCOUNT_PERCENTAGE,
  PLAN_SHUFFLE_UPDATE_URL,
  MAKE_PACKAGE_BUILD_URL,
  ZONE_LIST_ACCOMMODATION_DATA_MASTER,
  SET_PACKAGE_BASIC_DETAILS
} from "../constants";

export const addToCart = (data) => {
  return {
    type: ADD_TO_CART,
    data: data
  }
}
export const removeToCart = (data) => {
  return {
    type: REMOVE_TO_CART,
    data: data
  }
}
export const clearToCart = () => {
  return {
    type: CLEAR_TO_CART,
  }
}

export const updateToCart = (data) => {
  return {
    type: OVERLAP_TO_CART,
    data: data
  }
}


export const adminPackageMainIndex = (index) => ({
  type: ADMIN_PACKAGE_CURRENT_MAIN_INDEX,
  payload: index,
});

export const adminPackageCurrentChildIndex = (index) => ({
  type: ADMIN_PACKAGE_CURRENT_CHILD_INDEX,
  payload: index,
});

export const addAdminPackageMainItem = (item, itinerary_type) => ({
  type: ADD_ADMIN_PACKAGE_MAIN_ITEM,
  payload: { item, itinerary_type },
});

export const updateAdminPackageMainItem = (index, item) => ({
  type: UPDATE_ADMIN_PACKAGE_MAIN_ITEM,
  payload: { index, item },
});

export const removeAdminPackageMainItem = (index) => ({
  type: REMOVE_ADMIN_PACKAGE_MAIN_ITEM,
  payload: index,
});

export const addAdminPackageChildItem = (mainIndex, childItem) => ({
  type: ADD_ADMIN_PACKAGE_CHILD_ITEM,
  payload: { mainIndex, childItem },
});

export const updateAdminPackageChildItem = (mainIndex, childIndex, childItem) => ({
  type: UPDATE_ADMIN_PACKAGE_CHILD_ITEM,
  payload: { mainIndex, childIndex, childItem },
});

export const removeAdminPackageChildItem = (mainIndex, childIndex) => ({
  type: REMOVE_ADMIN_PACKAGE_CHILD_ITEM,
  payload: { mainIndex, childIndex },
});

export const clearAdminPackageCart = () => ({
  type: CLEAR_ADMIN_PACKAGE_CART,
});

export const setAdminPackageCart = (packages) => ({
  type: SET_ADMIN_PACKAGE_CART,
  payload: packages,
});

export const setCustomerPackageCart = () => ({
  type: SET_CUSTOMER_PACKAGE_CART,
});

export const updateCustomerPackageChildSelectItem = (mainIndex, newChildIndex) => ({
  type: UPDATE_CUSTOMER_PACKAGE_CHILD_SELECT_ITEM,
  payload: { mainIndex, newChildIndex },
});

export const setCustomerPackageDiscountPercentage = (percentage) => ({
  type: SET_CUSTOMER_DISCOUNT_PERCENTAGE,
  payload: percentage,
});

export const setMakePackageBuildUrl = (url) => ({
  type: MAKE_PACKAGE_BUILD_URL,
  payload: url,
});

export const setPlanShuffleUpdateUrl = (url) => ({
  type: PLAN_SHUFFLE_UPDATE_URL,
  payload: url,
});

export const zoneListAccommodationDataMaster = (data) => ({
  type: ZONE_LIST_ACCOMMODATION_DATA_MASTER,
  payload: data,
});

export const setPackageBasic_details = (data) => ({
  type: SET_PACKAGE_BASIC_DETAILS,
  payload: data,
});
